<template>
  <screen
    :class="{ invisible: !show }"
    :screen-info="stepInfo"
    :step="stepIndex + 1"
    :can-skip="true"
    @leave="$emit('leave')"
    @skip="$emit('skip')"
  >
    <slider @mounted="initSlider">
      <!-- Make phone vertical -->
      <div class="splide__slide">
        <img
          src="../../../assets/MobileScan/vertical-phone.svg"
          :alt="$t('mobileScan.vertical_info')"
        />
      </div>
      <!-- Make sure whole body is in screen -->
      <div class="splide__slide">
        <img src="../../../assets/MobileScan/in-screen.svg" :alt="$t('mobileScan.inscreen_info')" />
      </div>
      <!-- Back to correct position -->
      <div class="splide__slide">
        <back-off :show="backOff" />
      </div>
      <!-- Spin -->
      <div class="splide__slide">
        <spin :show="playSpin" @ended="onSpinDone" />
      </div>
    </slider>
    <step-dots :step="currentStep" :steps="totalSteps" />
  </screen>
</template>

<script>
import '@splidejs/splide/dist/css/splide-core.min.css';
import Splide from '@splidejs/splide';
import audioPlayer from '@/mixins/audio-player';
import Screen from '@/components/common/Screen.vue';
import Slider from '@/components/common/Slider.vue';
import StepDots from '@/components/common/StepDots.vue';
import Spin from '@/components/MobileScan/Tutorial/Spin.vue';
import BackOff from '@/components/MobileScan/Tutorial/BackOff.vue';

const SPLIDE_OPTIONS = {
  perPage: 1,
  arrows: false,
  width: 350,
};

export default {
  name: 'Slides',
  mixins: [audioPlayer],
  components: {
    Screen,
    Slider,
    StepDots,
    Spin,
    BackOff,
  },
  props: {
    show: Boolean,
  },
  data: () => ({
    stepIndex: 0,
    backOff: false,
    playSpin: false,
  }),
  beforeDestroy() {
    this.destroySlider();
  },
  methods: {
    initSlider() {
      if (this.$splide) {
        this.$splide.destroy();
        this.$splide = null;
      }
      const $splide = document.querySelector('.splide');
      if ($splide) {
        this.$splide = new Splide($splide, SPLIDE_OPTIONS).mount();
        this.$splide.on('moved', this.onSlideMoved);
      } else {
        console.log('slide container is not there');
      }
    },
    onSlideMoved(index) {
      this.stepIndex = index;
      this.backOff = false;
      this.playSpin = false;
      if (index === 0) {
        this.playAudio('ms-05-vertical', true);
      } else if (index === 1) {
        this.playAudio('ms-06-in_screen', true);
      } else if (index === 2) {
        this.playAudio('ms-07-back_off', true);
        this.backOff = true;
      } else if (index === 3) {
        this.playAudio('ms-08-arms_open', true).then(() => this.onSpinDone());
        this.playSpin = true;
      }
    },
    onSpinDone() {
      this.playSpin = false;
      if (!this.isPlaying && this.isLastStep) {
        this.$emit('next');
      }
    },
    destroySlider() {
      if (this.$splide) {
        this.$splide.destroy();
      }
      this.$splide = null;
    },
  },
  computed: {
    stepInfo() {
      const info = [
        this.$t('mobileScan.vertical_info'),
        this.$t('mobileScan.inscreen_info'),
        this.$t('mobileScan.backoff_info'),
        this.$t('mobileScan.spin_info'),
      ];
      return info[this.stepIndex];
    },
    currentStep() {
      return this.stepIndex + 1;
    },
    isLastStep() {
      return this.currentStep === this.totalSteps;
    },
    totalSteps() {
      return 4;
    },
  },
  watch: {
    show(nv) {
      if (nv) {
        this.playAudio('ms-05-vertical', true);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.splide__slide {
  @apply flex justify-center items-center;
  min-height: 300px;
  width: 350px;
}
</style>
